/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitTag,
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import {
    PressKitThumbnailUrls,
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * 
 * @export
 * @interface PressKitDocumentListByCompanyIdResults
 */
export interface PressKitDocumentListByCompanyIdResults {
    /**
     * PressKit Image UUID(v4)
     * @type {string}
     * @memberof PressKitDocumentListByCompanyIdResults
     */
    id: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitDocumentListByCompanyIdResults
     */
    title: string;
    /**
     * ファイル拡張子（原則英語小文字）
     * @type {string}
     * @memberof PressKitDocumentListByCompanyIdResults
     */
    extension: PressKitDocumentListByCompanyIdResultsExtensionEnum;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitDocumentListByCompanyIdResults
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitDocumentListByCompanyIdResults
     */
    downloadUrl: string;
    /**
     * 企業が設定しているタグの一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitDocumentListByCompanyIdResults
     */
    readonly tags: Array<PressKitTag>;
}

/**
* @export
* @enum {string}
*/
export enum PressKitDocumentListByCompanyIdResultsExtensionEnum {
    Pdf = 'pdf'
}

export function PressKitDocumentListByCompanyIdResultsFromJSON(json: any): PressKitDocumentListByCompanyIdResults {
    return PressKitDocumentListByCompanyIdResultsFromJSONTyped(json, false);
}

export function PressKitDocumentListByCompanyIdResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitDocumentListByCompanyIdResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'extension': json['extension'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitDocumentListByCompanyIdResultsToJSON(value?: PressKitDocumentListByCompanyIdResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'extension': value.extension,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
    };
}

